import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, ActivatedRoute, NavigationEnd } from '@angular/router';
import { catchError, firstValueFrom, map, Observable, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import jwt_decode from "jwt-decode";
import { AppSettings } from '../app-settings';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  hasError() {
    this.router.navigate(['/login']).then(() => { if (localStorage.getItem('jwt_token')) { this.authenticationService.logout() } });
    return false;
  }

  /**
   * En el tótem no hay login de cliente: en vez de echar al usuario, se
   * recupera la sesión del kiosco. Si tampoco se puede, se vuelve a la home
   * del tótem sin borrar nada.
   */
  private recoverTotemSession(): Observable<boolean> {
    return this.authenticationService.ensureTotemSession().pipe(
      map((user: any) => {
        if (user) {
          return true;
        }
        this.router.navigate(['/home-totem']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/home-totem']);
        return of(false);
      })
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    var token = localStorage.getItem('jwt_token');
    if (token === null) {
      return AppSettings.ENV_TOTEM ? this.recoverTotemSession() : this.hasError();
    }
     return this.authenticationService.getUsersMe().pipe(map((response: any) => {
        // if (response.organizer && state.url != "/profile/edit") {
        //   this.router.navigate(['/panel']);
        //   return false;
        // }
        if (response.success) {
          return true;
        } else {
          return this.hasError();
        }
      }), catchError(err => { return AppSettings.ENV_TOTEM ? this.recoverTotemSession() : of(this.hasError()) }));
  }

}
